const IPC_EVENT = {
    // 依照使用者電腦設定開啟檔案
    OPEN_EXE: "openExe",
    // 開啟一般網頁
    OPEN_WEB_SITE: "openWebSite",
    // 取得資料夾權限
    GET_FOLDER_PERMISSIONS: "getFolderPermissions",
    // 檢查更新
    CHECK_UPDATE: "checkUpdate",
    // 關閉應用程式
    EXIT: "exit",
    // 查詢app啟動的位置
    GET_APP_PATH: "getAppPath",
    // search path
    GET_PATH: "getPath",
    // return book path
    RETURN_BOOK_PATH: "returnBookPath",
    // 新增使用者紀錄
    ADD_USER_RECORD: "addUserRecord",
    // 更新使用者紀錄
    UPDATE_USER_RECORD: "updateUserRecord",
    // 確認記錄名稱有無重複
    CHECK_LOG_NAME_REPEAT: "checkLogNameRepeat",
    // 存檔完成
    FINISH_SAVE: "finishSave",
    // 選擇另存新檔路徑
    SELECT_SAVE_NEW_FILE_PATH: "selectSaveNewFilePath",
    // 查詢使用者紀錄
    GET_USER_RECORD: "getUserRecord",
    // 切換全螢幕/視窗
    SWITCH_FULLSCREEN_WINDOW: "switchFullScreenWindow",
    // 開啟其他紀錄
    SELECT_OTHER_RECORD: "selectOtherRecord",
    // 儲存GoogleCloudStorage上的使用者紀錄到本機
    ADD_CLOUD_USER_RECORD_TO_LOCAL: "addCloudUserRecordToLocal",
    // 更新GoogleCloudStorage的使用者紀錄到本機
    UPDATE_CLOUD_USER_RECORD_TO_LOCAL: "updateCloudUserRecordToLocal",
    // 刪除使用者紀錄(實體檔案刪除,紀錄會標記為刪除)
    DELETE_USER_RECORD: "deleteUserRecord",
    // start single login 開始單一入口登入
    SINGLE_LOGIN: "startSingleLogin",
    // finish single login 完成單一入口登入
    SINGLE_LOGIN_FINISH: "singleLoginFinish",
    // set bookId
    SET_BOOK_ID: "setBookId",
    // get copied image, copy image to tempFolder, change fileName 
    // 複製引用的圖片到暫存區, 並回傳複製到的位置
    GET_COPIED_IMAGE: "getCopiedImage",
    // copy image to tempFolder, without change fileName 
    // 複製引用圖片到暫存區, 不修改檔案名稱
    COPY_IMAGE: "copyImage",
    // open web page in sub window 使用子視窗開啟網頁
    OPEN_WEB_PAGE_IN_SUB_WINDOW: "openWebPageInSubWindow",
    // detect record folder 檢查存放目前存檔的資料夾檔案變動
    DETECT_RECORD_FOLDER: "detectRecordFolder",
    // load record 讀取使用者紀錄
    LOAD_RECORD: "loadRecord",
    // ready 前端已經初始化好可以接收 後端發來的ipc訊息
    READY: "ready",
    // 儲存圖片
    SAVE_IMAGE: "save_image",
    // 刪除圖片
    REMOVE_IMAGE: "remove_image",
    // get platform 取得系統
    GET_PLATFORM: 'getPlatform',
    // 本機自動存檔
    AUTO_SAVE_LOCAL: 'autoSaveLocal',
    // 回到書櫃
    BACK_TO_BOOKCASE: 'backToBookcase',
    // 以下事件為app呼叫
    // 接收app傳遞的使用者紀錄
    SET_USER_RECORD_FROM_APP: "setUserRecordFromApp",
    // 接收app新增存檔結束
    ADD_USER_RECORD_FINISH: "addUserRecordFinish",
    // 接收app更新存檔結束
    UPDATE_USER_RECORD_FINISH: "updateUserRecordFinish",
    // 接收app刪除存檔結束
    DELETE_USER_RECORD_FINISH: "deleteUserRecordFinish",
    // 插入圖片超過大小限制
    MOBILE_IMAGE_OVER_SIZE: 'mobileImageOverSize',
    // 接收app自動存檔結束
    AUTO_SAVE_FINISH: 'autoSaveFinish',
    // 複製插入圖片結束
    COPY_INSERT_IMAGE_FINISH: 'copyInsertImageFinish'
}

export { IPC_EVENT };